import { render, staticRenderFns } from "./AppDragHandle.vue?vue&type=template&id=3b44e0f5&scoped=true&"
var script = {}
import style0 from "./AppDragHandle.vue?vue&type=style&index=0&id=3b44e0f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44e0f5",
  null
  
)

export default component.exports